import { CSSObject } from "@emotion/react";
import {
  AngelouCSS,
  ButtonStyleOverrides,
  typographyStyles,
  constants,
  mediaQueryStyles,
} from "@newsela/angelou";

const { fontFamily } = typographyStyles;
const {
  colors: { ui },
  breakpoints: { BreakpointNames },
} = constants;
const { mediaQuery } = mediaQueryStyles;

export const basicFlexContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const editableHeaderCss: CSSObject = {
  ...basicFlexContainerCss,
  justifyContent: "space-between",
  width: "100%",
  height: "72px",
  padding: "12px 32px",

  ...fontFamily.circular,

  borderBottom: `1px solid ${ui.neutral[100]}`,

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    height: "100px",
  },
};

export const editButtonCss: ButtonStyleOverrides<AngelouCSS> = {
  root: {
    "@media (max-width: 418px)": {
      width: "100%",
      justifyContent: "center",
    },
  },
};

export const titleAndSubtitleContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
};

export const headerContainerCss: CSSObject = {
  width: "100%",
  minHeight: "106px",
  maxHeight: "100%",
  backgroundColor: ui.beige[25],
  padding: "12px 32px",
  paddingBottom: 0,
  marginBottom: "-12px",
};

export const inputAndFiltersCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  [mediaQuery.downTo(BreakpointNames.sm)]: {
    marginTop: "-14px",
  },

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    flexDirection: "column",
  },
};

export const titleInputContainerCss: CSSObject = {
  width: "100%",

  [mediaQuery.downTo(BreakpointNames.sm)]: {
    width: "300px",
  },
};

export const filtersCss: CSSObject = {
  [mediaQuery.downTo(BreakpointNames.sm)]: {
    marginTop: "26px",
  },
};

export const selectedChipsCss: CSSObject = {
  backgroundColor: ui.beige[25],
  padding: "12px 32px",
  position: "sticky",
  top: 0,
  zIndex: 2,
};
